<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text1 animate-target" v-animate-in>Watch clinical commentary from Roberto Pecoits-Filho, MD, PhD, FASN, FACP.</div>
    <div class="ctn-text2 animate-target" v-animate-in>Dr Roberto Pecoits-Filho is a Nephrologist and Research Scientist at Arbor Research, Michigan and Pontifical Catholic University of Paraná</div>
    <iframe class="p-video animate-target" v-animate-in
      src="https://player.vimeo.com/video/1219778568?h=7145e3e001&title=0&byline=0&portrait=0&autoplay=1"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen>
    </iframe>
    <GoNext class="animate-target" v-animate-in href="/section5/">Next</GoNext>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import {mapState} from "vuex";

export default {
  name: "s4-9",
  components: {SectionTitle, GoNext},
  computed:{
  },
  data(){
    return{
      title:"Closing thoughts"
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section4/s4.css";
.ctn-text1 {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  margin-top: 40px;
}
.ctn-text2 {
  font-size: 20px;
  color: #000;
  margin-top: 30px;
}
.p-video {
  margin-top: 30px;
  width:100%;
  aspect-ratio: 16/9;
}
</style>
